export const MIN_WIN_AMOUNT_CENTS = 1500;
export const MAX_WIN_AMOUNT_CENTS = 20_000;

export const MIN_MBTC_AMOUNT = 0.22;
export const MAX_MBTC_AMOUNT = 3.4;

export interface NewWinnerI {
  nickname: string;
  gameTitle: string;
  humanizedWin: string;
  gameTableImagePath: string;
  gameFullPath?: string;
  onClick?: () => void;
}
